// extracted by mini-css-extract-plugin
module.exports = {"date":"UsersChat_date__3UmqK","lastMessage":"UsersChat_lastMessage__2wd4C","userImage":"UsersChat_userImage__3_sAN","cardEffect":"UsersChat_cardEffect__3RjKU"};